import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { State } from '../state';

export const selectBpmnProcessState: MemoizedSelector<
  object,
  State
  > = createFeatureSelector<State>('BpmnProcess');















